import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

import { format } from 'date-fns/format';

import { removeTimezoneFromIsoTimeString } from '../../utils/date-helper';

/**
 * @slot unnamed - Slot to render the pear-chain component
 */

@Component({
  shadow: true,
  styleUrl: 'paf-result-pearl-chain-time.scss',
  tag: 'paf-result-pearl-chain-time',
})

export class PafResultPearlChainTime implements ComponentInterface {

  /**
   * Arrival time defined as ISO 8601 timestamp (e.g. 2022-12-11T14:11:00),
   * will be transformed and rendered in HH:MM format (14:11).
  */
  @Prop() public arrivalTime!: string;

  /**
   * Departure time defined as ISO 8601 timestamp (e.g. 2022-12-11T14:11:00),
   * will be transformed and rendered in HH:MM format (14:11).
  */
  @Prop() public departureTime!: string;

  /**
   * Optional prop to render the walk time (in minutes) after
   * arrival
   */
  @Prop() public arrivalWalk?: number;

  /**
   * Optional prop to render the walk time (in minutes) before
   * departure
   */
  @Prop() public departureWalk?: number;

  /**
   * If set to true, the component will show a loading skeleton
   */
  @Prop() public loading?: boolean;

  /**
   * Show wheelchair icon instead of walking person
  */
  @Prop() public wheelchair?: boolean;

  public render(): HTMLDivElement {
    const departureTimeWithoutTimezone = removeTimezoneFromIsoTimeString(this.departureTime);
    const arrivalTimeWithoutTimezone = removeTimezoneFromIsoTimeString(this.arrivalTime);
    const movementTypeIconPath = this.wheelchair
      ? 'M10.5 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.5 8.5V8h1v5h5v6h-1v-5h-5zm-3.995 1c0-1.75 1.01-3.27 2.471-4.014l.454.891A3.51 3.51 0 0 0 7.005 14.5c0 1.922 1.578 3.5 3.5 3.5 1.39 0 2.605-.826 3.168-2.018l.904.428A4.52 4.52 0 0 1 10.505 19a4.514 4.514 0 0 1-4.5-4.5'
      : 'M11.5 5c-.257 0-.5.243-.5.5s.243.5.5.5.5-.243.5-.5-.243-.5-.5-.5m-1.5.5c0-.81.69-1.5 1.5-1.5s1.5.69 1.5 1.5S12.309 7 11.5 7 10 6.31 10 5.5M11 9v4h1V9zm-1 .434v6.914l-1.916 2.874.832.555 2-3 .084-.126V14h1.293L14 15.707V20h1v-4.707l-.146-.147L13 13.293V9.707l1.146 1.146.147.147H17v-1h-2.293l-1.853-1.854L12.707 8H10.35l-.126.084-3 2-.223.148V14h1v-3.233z';

    return (
      <div class={{
        'loading': this.loading,
        'paf-result-pearl-chain-time': true,
      }}>
        {this.loading &&
          <div class='loader'></div>
        }

        <div class='paf-result-pearl-chain-time__departure'>

          {(this.departureWalk && this.departureWalk !== 0) === true &&
            <p class='paf-result-pearl-chain-time__departure-walk-text'>
              <svg class='paf-result-pearl-chain-time__departure-walk-icon' viewBox='0 0 24 24'>
                <path d={movementTypeIconPath}/>
              </svg>
              {this.departureWalk}'
            </p>
          }
          <time class='paf-result-pearl-chain-time__departure-time' dateTime={this.departureTime}>
            {format(departureTimeWithoutTimezone, 'HH:mm')}
          </time>
        </div>
        <slot />
        <div class='paf-result-pearl-chain-time__arrival'>
          <time class='paf-result-pearl-chain-time__arrival-time' dateTime={this.arrivalTime}>
            {format(arrivalTimeWithoutTimezone, 'HH:mm')}
          </time>
          {(this.arrivalWalk && this.arrivalWalk !== 0) === true &&
            <p class='paf-result-pearl-chain-time__arrival-walk-text'>
              <svg class='paf-result-pearl-chain-time__arrival-walk-icon' viewBox='0 0 24 24'>
                <path d={movementTypeIconPath}/>
              </svg>
              {this.arrivalWalk}'
            </p>
          }
        </div>
      </div>
    );
  }
}
